import {useSelector} from "react-redux";
import {useEffect, useState} from "react";

const useErganiInstallationOptions = (includeAllValue = false) => {
    const erganiInstallations = useSelector((state) => state.PAYROLL.erganiInstallations);

    const [installationOptions, setInstallationOptions] = useState([]);

    useEffect(() => {
        if (erganiInstallations.length > 0) {
            let options = [];
            if (includeAllValue) options.push({value: "", label: "Όλες"})
            erganiInstallations.forEach((inst) => {
                options.push({ value: inst.installationMasterId, label: inst.address });
            })
            setInstallationOptions(options);
        }
    }, [])

    return installationOptions;
}

export default useErganiInstallationOptions;
